import type { SVGProps } from "react";
export function InfoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-slot="icon"
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="currentColor">
        <path d="m2.97297 7c0-2.77635 2.25068-5.02703 5.02703-5.02703 2.7764 0 5.027 2.25068 5.027 5.02703 0 2.61097-1.9912 4.7576-4.53735 5.0036-.42906.0415-.87415.2065-1.21368.546l-1.3486 1.348c-.03558.0356-.06671.0465-.09185.0494-.02916.0034-.06447-.0026-.09882-.0209-.0344-.0184-.05883-.0448-.07221-.0709-.0115-.0226-.02064-.0546-.01077-.1039l.22867-1.1421c.05268-.2634-.11801-.5199-.38133-.5727-.26338-.0526-.51984.118-.57264.3814l-.22867 1.1427c-.22025 1.1013 1.12201 1.8197 1.91617 1.0255l1.34797-1.3486c.14696-.1469.36377-.2406.61951-.2654 3.0401-.2937 5.4166-2.8552 5.4166-5.9721 0-3.31371-2.6863-6-6-6-3.31371 0-6 2.68629-6 6 0 1.54384.58382 2.95241 1.54181 4.0154.17988.1996.48771.216.68729.0361s.21535-.4877.03547-.6873c-.80325-.89122-1.2916-2.07011-1.2916-3.3642z" />
        <path d="m7.51354 9.91893v-1.14337c.00001-.80751.55179-1.4245.92674-1.86613.43575-.51327.69489-.85176.69489-1.23649-.00016-.60213-.49987-1.10536-1.13514-1.10536s-1.13498.50323-1.13513 1.10536c0 .26868-.21781.48649-.48649.48649s-.48649-.21781-.48649-.48649c.00016-1.15623.95238-2.07834 2.10811-2.07834s2.10797.92211 2.10807 2.07834c0 .80752-.55175 1.4245-.92669 1.86613-.43585.51336-.69489.85172-.69489 1.23649v1.14337c0 .26867-.21781.48647-.48649.48647s-.48649-.2178-.48649-.48647z" />
      </g>
    </svg>
  );
}
